export const Permissions = {
    activity: {
        create: ['activity.create.*'],
        edit: ['activity.update.*'],
        delete: ['activity.delete.*'],
    },
    client: {
        create: ['client.create.*'],
        status: ['client.update.status', 'client.delete.*'],
        edit: ['client.update.*'],
        delete: ['client.delete.*'],
        takeover: ['organisation.create'],
        bind: ['client.bind'],
        unbind: ['client.unbind'],
        read: ['client.read.*'],
    },
    clientmapping: {
        create: ['mapping.create.*'],
        read: ['mapping.read.*'],
    },
    notification: {
        create: ['notification.create.*'],
    },
    organisation: {
        read: ['organisation.read'],
        update: ['organisation.update'],
        create: ['organisation.create'],
        bind: ['organisation.bind'],
        unbind: ['organisation.unbind'],
    },
    unit: {
        read: ['unit.read'],
        update: ['unit.update'],
        create: ['unit.create'],
        delete: ['unit.delete', 'sections.sidenav'],
        bind: ['unit.bind'],
        unbind: ['unit.unbind'],
    },
    post: {
        create: ['post.create'],
    },
    report: {
        read: ['report.read.*'],
        create: ['report.create.*'],
    },
    definitions: {
        coach: 'coach',
        participant: 'participant',
    },
    sections: {
        sidenav: ['sidemenu.read'],
    },
    roles: {
        god: ['*.*.*'],
        inhabitant: [''],
        coach: ['client.read'],
    },
    media: {
        alias: ['*.*.*'],
    },
};
